import { createSelector } from 'reselect';
import { POPULAR_PLANS_BY_CARRIER_STATE_KEY } from '../../constants';
import { carrierSelector } from '../carriers';
import insurancePickerSelector from '../insurancePickerSelector';

const popularPlansByCarrierSelector = createSelector(
    insurancePickerSelector,
    insurance => insurance[POPULAR_PLANS_BY_CARRIER_STATE_KEY]
);

const popularPlansSelector = createSelector(
    popularPlansByCarrierSelector,
    carrierSelector,
    (popularPlansByCarrier, carrierId) => popularPlansByCarrier[carrierId]
);

export {
    popularPlansSelector,
    popularPlansByCarrierSelector,
};
